import { useSessionContext } from "@supabase/auth-helpers-react";
import { BrowserSupabase } from "../../lib/supabase";


export function useSupabase(): BrowserSupabase {
  const context = useSessionContext();
  const client = context.supabaseClient;
  // context.supabaseClient.auth.signInWithOtp()
  (client as any).type = "browser";
  return client as BrowserSupabase;
}
